<template lang="">
  <div>
    <div id="list_top">
      <div class="w_1180">
        <h1><strong class="cs_pad3">创业就找创业小鸟</strong>与创新者同行，发现未来</h1>
      </div>
    </div>
    <Nav />
    <div class="w_1180 about_sum1">
      <strong>创业&amp;团队</strong>
      <p>创业是个失败概率很大的事情，<br>我们很高兴从2008年到现在还活着， 而且还活得很nice。</p>
    </div>
    <div class="w_1180 about_sum1">
      <strong>工作氛围</strong>
      <p>
        我们的工作不是很轻松，但我们的氛围很轻松。我们倡导简单直接的沟通方式，希望做一家透明的公司，在阳光下办事。这里并没有职位的等级划分，我们头儿很nice，没有任何架子，是最不像老板的老板。我们立志要让创业变得更加简单，更加美好。你可以随时提出自己的意见和任何人PK。
      </p>
      <p>这不是一份工作，这是一项事业！你可以体验创业的感觉，了解创业的快乐和艰辛！你可以学到关于创建公司、建立品牌、市场拓展、营销策划、财务管理、投资招商等所有创业技能！</p>
      <p>我们还为每位员工提供广阔的成长空间和职业发展双通道发展，使员工在最适合自己的发展路径上持续深入，不断攀升。</p>
    </div>
    <div class="w_1180 about_sum1">
      <strong>工作环境</strong>
      <!--三屏旋转切换-->
      <div id="featured-area">
        <swiper :options="swiperOptions" class="roundabout-holder" style="padding: 0px; position: relative;">
          <swiper-slide v-for="(item,index) in pictureList" :key="index"
            class="roundabout-moveable-item roundabout-in-focus" style="">
            <a href="/join">
              <span><em>{{item.title}}</em>{{item.description}}</span>
              <img :src="item.picture">
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="w_1180 about_sum1 clearfix">
      <strong>公司福利</strong>
      <div class="about_sum1_dl">
        <dl>
          <dt><span>基本</span>五险一金<br>（社会保险+住房公积金）</dt>
        </dl>
        <dl>
          <dt><span>假期</span>周末双休，国家法定节假日，<br>带薪年假、婚假、产假一应俱全</dt>
        </dl>
        <dl>
          <dt><span>津贴</span>餐费补贴、交通补贴、<br>住房补贴、话费补贴</dt>
        </dl>
        <dl>
          <dt><span>福利</span>生日会、节日福利、<br>下午茶、聚餐、团建活动等</dt>
        </dl>
        <dl>
          <dt><span>奖金</span>月度奖金、季度奖金<br>年终奖金、特别奖</dt>
        </dl>
        <dl>
          <dt><span>培训</span>新人培训，管理培训，<br>公费出外培训、职业生涯规划</dt>
        </dl>
      </div>
    </div>
    <div class="w_1180 about_sum1">
      <strong>联系方式</strong>
      <p class="fc2"><span class="fc">简历投递：</span>hr@cyxn.com<br><span class="fc">人才服务热线：</span>0757-8361 1111（招募一流人才）
      </p>
      <p>肺话不多说，就差你了！赶紧来小鸟吃下午茶和团聚活动吧！</p>
      <div class="img"><img src="@/assets/images/a_pic1.png"></div>
      <div class="img"><img src="@/assets/images/a_pic2.jpg"></div>
    </div>
  </div>
</template>
<script>
  import Nav from '../nav'
  export default {
    components: {
      Nav
    },
    data() {
      return {
        pictureList: [],
        swiperOptions: {
          slidesPerView: 1.25,
          centeredSlides: true,
          spaceBetween: 30,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          },
        }
      }
    },
    mounted() {
      this.getPicture()
    },
    methods: {
      async getPicture() {
        let res = await this.$request.post('environment/getAll')
        if (res.data.code === 0) {
          this.pictureList = res.data.data
        }
      },
    },
  }
</script>
<style lang="css" scoped>
  .swiper-slide {
    width: 98%;
    height: 73%;
  }
</style>